import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";

const schema = {
  pattern: {
    value: /^[^ -~｡-ﾟ]+$/,
    message: TkPropertyMessageGet("TKMSG_SCR0061E"),
  },
  maxLength: {
    value: 85,
    message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
  },
};

export { schema };
